export default __webpack_public_path__ + "static/media/002-French flag.914efe02.svg";